import { languageGlobal } from "./GlobalVariableConfig";

export const getManifest = () => {
    return {
        bundles: [
            {
                name: 'intro-screen',
                assets: [
                    // {
                    //     alias: 'volatilityBase',
                    //     src: 'assets/desktop/intro/vol_base.webp',
                    // },
                    {
                        alias: 'volatilityOn',
                        src: 'assets/desktop/2_intro/volatility_on.webp',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    {
                        alias: 'volatilityOff',
                        src: 'assets/desktop/2_intro/volatility_off.webp',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    {
                        alias: 'intro_bg',
                        src: 'assets/desktop/2_intro/intro_bg.webp',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    {
                        alias: 'textBase',
                        src: 'assets/desktop/2_intro/ticket.webp',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    {
                        alias: 'image1',
                        src: 'assets/desktop/2_intro/image_1.png',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    {
                        alias: 'image2',
                        src: 'assets/desktop/2_intro/image_2.png',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    {
                        alias: 'image3',
                        src: 'assets/desktop/2_intro/image_3.png',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    // {
                    //     alias: 'continueBase',
                    //     src: './intro/click_base.webp',
                    // },
                    // {
                    //     alias: 'introAppearSound',
                    //     src: 'assets/desktop/13_sound/gameloading/Intro_appear.mp3',
                    // },
                ]
            },
            {
                name: 'big-win',
                assets: [
                    {
                        alias: 'bigWinSkel',
                        src: languageGlobal === 'es-es' ? 'assets/desktop/9_bigwin/es/spanish_wins.skel' : 'assets/desktop/9_bigwin/wins.skel',
                    },
                    {
                        alias: 'bigWinAtlas',
                        src: languageGlobal === 'es-es' ? 'assets/desktop/9_bigwin/es/spanish_wins.atlas' : 'assets/desktop/9_bigwin/wins.atlas',
                        data: {
                            imageMetadata: {
                                alphaMode: 'no-premultiply-alpha'
                            }
                        }
                    },
                    // {
                    //     alias: 'amount_base',
                    //     src: 'assets/desktop/bigwin/win_amount_base.webp',
                    // },
                ]
            },
            {
                name: 'common',
                assets: [
                    // //logo animation *********************
                    {
                        alias: 'logoSkel',
                        src: 'assets/desktop/4_logo/logo.skel',
                    },
                    {
                        alias: 'logoAtlas',
                        src: 'assets/desktop/4_logo/logo.atlas',
                        data: {
                            imageMetadata: {
                                alphaMode: 'no-premultiply-alpha'
                            }
                        }
                    },
                    // reels back
                    {
                        alias: 'reelBackSkel',
                        src: 'assets/desktop/10_reel/reel/reel.skel',
                    },
                    {
                        alias: 'reelBackAtlas',
                        src: 'assets/desktop/10_reel/reel/reel.atlas',
                        data: {
                            imageMetadata: {
                                alphaMode: 'no-premultiply-alpha'
                            }
                        }
                    },
                    // jackpot meter
                    {
                        alias: 'jackpotMeterSkel',
                        src: 'assets/desktop/14_feature/jackpotMeter/meters.skel',
                    },
                    {
                        alias: 'jackpotMeterAtlas',
                        src: 'assets/desktop/14_feature/jackpotMeter/meters.atlas',
                        data: {
                            imageMetadata: {
                                alphaMode: 'no-premultiply-alpha'
                            }
                        }
                    },
                    // jackpot base meter
                    {
                        alias: 'jackpotBaseMeterSkel',
                        src: 'assets/desktop/14_feature/current_jackpot_base/current_jackpot_base.skel',
                    },
                    {
                        alias: 'jackpotBaseMeterAtlas',
                        src: 'assets/desktop/14_feature/current_jackpot_base/current_jackpot_base.atlas',
                        data: {
                            imageMetadata: {
                                alphaMode: 'no-premultiply-alpha'
                            }
                        }
                    },

                    {
                        alias: 'freegame_intro_outro_atlas',
                        src: 'assets/desktop/7_banner/intro_outro.atlas',
                        data: {
                            imageMetadata: {
                                alphaMode: 'no-premultiply-alpha'
                            }
                        }
                    },
                    {
                        alias: 'freegame_intro_outro_skel',
                        src: 'assets/desktop/7_banner/intro_outro.skel',
                    },

                    //Sccarab banner
                    {
                        alias: 'banner_bg',
                        src: 'assets/desktop/7_banner/bg.webp',
                    },

                    // Transition
                    {
                        alias: 'bannerTransitionSkel',
                        src: 'assets/desktop/15_transition/transition.skel',
                    },
                    {
                        alias: 'bannerTransitionAtlas',
                        src: 'assets/desktop/15_transition/transition.atlas',
                        data: {
                            imageMetadata: {
                                alphaMode: 'no-premultiply-alpha'
                            }
                        }
                    },
                    //symbols *********************
                    //hv1
                    {
                        alias: 'hv1Skel',
                        src: 'assets/desktop/12_symbols/hv1/hv_1.skel',
                    },
                    {
                        alias: 'hv1Atlas',
                        src: 'assets/desktop/12_symbols/hv1/hv_1.atlas',
                        data: {
                            imageMetadata: {
                                alphaMode: 'no-premultiply-alpha'
                            }
                        }
                    },
                    {
                        alias: 'hv1Static',
                        src: 'assets/desktop/12_symbols/hv1/hv_1Static.webp',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    {
                        alias: 'hv1Blur',
                        src: 'assets/desktop/12_symbols/hv1/hv_1Blur.webp',
                        data: {
                            imageMetadata: {
                                alphaMode: 'no-premultiply-alpha'
                            }
                        }
                    },
                    //hv2
                    {
                        alias: 'hv2Skel',
                        src: 'assets/desktop/12_symbols/hv2/hv_2.skel',
                    },
                    {
                        alias: 'hv2Atlas',
                        src: 'assets/desktop/12_symbols/hv2/hv_2.atlas',
                        data: {
                            imageMetadata: {
                                alphaMode: 'no-premultiply-alpha'
                            }
                        }
                    },
                    {
                        alias: 'hv2Static',
                        src: 'assets/desktop/12_symbols/hv2/hv_2Static.webp',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    {
                        alias: 'hv2Blur',
                        src: 'assets/desktop/12_symbols/hv2/hv_2Blur.webp',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    //hv3
                    {
                        alias: 'hv3Skel',
                        src: 'assets/desktop/12_symbols/hv3/hv_3.skel',
                    },
                    {
                        alias: 'hv3Atlas',
                        src: 'assets/desktop/12_symbols/hv3/hv_3.atlas',
                        data: {
                            imageMetadata: {
                                alphaMode: 'no-premultiply-alpha'
                            }
                        }
                    },
                    {
                        alias: 'hv3Static',
                        src: 'assets/desktop/12_symbols/hv3/hv_3Static.webp',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    {
                        alias: 'hv3Blur',
                        src: 'assets/desktop/12_symbols/hv3/hv_3Blur.webp',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    //hv4
                    {
                        alias: 'hv4Skel',
                        src: 'assets/desktop/12_symbols/hv4/hv_4.skel',
                    },
                    {
                        alias: 'hv4Atlas',
                        src: 'assets/desktop/12_symbols/hv4/hv_4.atlas',
                        data: {
                            imageMetadata: {
                                alphaMode: 'no-premultiply-alpha'
                            }
                        }
                    },
                    {
                        alias: 'hv4Static',
                        src: 'assets/desktop/12_symbols/hv4/hv_4Static.webp',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    {
                        alias: 'hv4Blur',
                        src: 'assets/desktop/12_symbols/hv4/hv_4Blur.webp',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    // hv5
                    // {
                    //     alias: 'hv5Skel',
                    //     src: 'assets/desktop/12_symbols/hv5/hv_5.skel',
                    // },
                    // {
                    //     alias: 'hv5Atlas',
                    //     src: 'assets/desktop/12_symbols/hv5/hv_5.atlas',
                    //     data: {
                    //         alphaMode: 'no-premultiply-alpha'
                    //     }
                    // },
                    // {
                    //     alias: 'hv5Static',
                    //     src: 'assets/desktop/12_symbols/hv5/hv_5Static.webp',
                    //     data: {
                    //         alphaMode: 'no-premultiply-alpha'
                    //     }
                    // },
                    // {
                    //     alias: 'hv5Blur',
                    //     src: 'assets/desktop/12_symbols/hv5/hv_5Blur.webp',
                    //     data: {
                    //         alphaMode: 'no-premultiply-alpha'
                    //     }
                    // },
                    //lv1
                    {
                        alias: 'lv1Skel',
                        src: 'assets/desktop/12_symbols/lv1/lv_1.skel',
                    },
                    {
                        alias: 'lv1Atlas',
                        src: 'assets/desktop/12_symbols/lv1/lv_1.atlas',
                        data: {
                            imageMetadata: {
                                alphaMode: 'no-premultiply-alpha'
                            }
                        }
                    },
                    {
                        alias: 'lv1Static',
                        src: 'assets/desktop/12_symbols/lv1/lv_1Static.webp',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    {
                        alias: 'lv1Blur',
                        src: 'assets/desktop/12_symbols/lv1/lv_1Blur.webp',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    //lv2
                    {
                        alias: 'lv2Skel',
                        src: 'assets/desktop/12_symbols/lv2/lv_2.skel',
                    },
                    {
                        alias: 'lv2Atlas',
                        src: 'assets/desktop/12_symbols/lv2/lv_2.atlas',
                        data: {
                            imageMetadata: {
                                alphaMode: 'no-premultiply-alpha'
                            }
                        }
                    },
                    {
                        alias: 'lv2Static',
                        src: 'assets/desktop/12_symbols/lv2/lv_2Static.webp',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    {
                        alias: 'lv2Blur',
                        src: 'assets/desktop/12_symbols/lv2/lv_2Blur.webp',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    //lv3
                    {
                        alias: 'lv3Skel',
                        src: 'assets/desktop/12_symbols/lv3/lv_3.skel',
                    },
                    {
                        alias: 'lv3Atlas',
                        src: 'assets/desktop/12_symbols/lv3/lv_3.atlas',
                        data: {
                            imageMetadata: {
                                alphaMode: 'no-premultiply-alpha'
                            }
                        }
                    },
                    {
                        alias: 'lv3Static',
                        src: 'assets/desktop/12_symbols/lv3/lv_3Static.webp',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    {
                        alias: 'lv3Blur',
                        src: 'assets/desktop/12_symbols/lv3/lv_3Blur.webp',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    //lv4
                    {
                        alias: 'lv4Skel',
                        src: 'assets/desktop/12_symbols/lv4/lv_4.skel',
                    },
                    {
                        alias: 'lv4Atlas',
                        src: 'assets/desktop/12_symbols/lv4/lv_4.atlas',
                        data: {
                            imageMetadata: {
                                alphaMode: 'no-premultiply-alpha'
                            }
                        }
                    },
                    {
                        alias: 'lv4Static',
                        src: 'assets/desktop/12_symbols/lv4/lv_4Static.webp',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    {
                        alias: 'lv4Blur',
                        src: 'assets/desktop/12_symbols/lv4/lv_4Blur.webp',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    //invalid
                    {
                        alias: 'invalidSkel',
                        src: 'assets/desktop/12_symbols/lv4/lv_4.skel',
                    },
                    {
                        alias: 'invalidAtlas',
                        src: 'assets/desktop/12_symbols/lv4/lv_4.atlas',
                        data: {
                            imageMetadata: {
                                alphaMode: 'no-premultiply-alpha'
                            }
                        }
                    },
                    {
                        alias: 'invalidStatic',
                        src: 'assets/desktop/12_symbols/lv4/lv_4Static.webp',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    {
                        alias: 'invalidBlur',
                        src: 'assets/desktop/12_symbols/lv4/lv_4Blur.webp',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    //scatter
                    {
                        alias: 'scatterSkel',
                        src: 'assets/desktop/12_symbols/scatter/scatter.skel',
                    },
                    {
                        alias: 'scatterAtlas',
                        src: 'assets/desktop/12_symbols/scatter/scatter.atlas',
                        data: {
                            imageMetadata: {
                                alphaMode: 'no-premultiply-alpha'
                            }
                        }
                    },
                    {
                        alias: 'scatterStatic',
                        src: 'assets/desktop/12_symbols/scatter/scatterStatic.webp',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    {
                        alias: 'scatterBlur',
                        src: 'assets/desktop/12_symbols/scatter/scatterBlur.webp',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    //wild
                    {
                        alias: 'wildSkel',
                        src: 'assets/desktop/12_symbols/wild/wild.skel',
                    },
                    {
                        alias: 'wildAtlas',
                        src: 'assets/desktop/12_symbols/wild/wild.atlas',
                        data: {
                            imageMetadata: {
                                alphaMode: 'no-premultiply-alpha'
                            }
                        }
                    },
                    {
                        alias: 'wildStatic',
                        src: 'assets/desktop/12_symbols/wild/wildStatic.webp',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    {
                        alias: 'wildBlur',
                        src: 'assets/desktop/12_symbols/wild/wildBlur.webp',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    //special_symbol
                    {
                        alias: 'specialSymbolSkel',
                        src: 'assets/desktop/12_symbols/special_symbol/special_symbol.skel',
                    },
                    {
                        alias: 'specialSymbolAtlas',
                        src: 'assets/desktop/12_symbols/special_symbol/special_symbol.atlas',
                        data: {
                            imageMetadata: {
                                alphaMode: 'no-premultiply-alpha'
                            }
                        }
                    },
                    {
                        alias: 'specialSymbolStatic',
                        src: 'assets/desktop/12_symbols/special_symbol/special_symbolStatic.webp',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    {
                        alias: 'specialSymbolBlur',
                        src: 'assets/desktop/12_symbols/special_symbol/special_symbolBlur.webp',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    // paylines animation
                    {
                        alias: 'winLineSkel',
                        src: 'assets/desktop/payline/payline.skel',
                    },
                    {
                        alias: 'winLineAtlas',
                        src: 'assets/desktop/payline/payline.atlas',
                        data: {
                            imageMetadata: {
                                alphaMode: 'no-premultiply-alpha'
                            }
                        }
                    },
                    // trail
                    {
                        alias: 'trailSkel',
                        src: 'assets/desktop/14_feature/trail/skeleton.skel',
                    },
                    {
                        alias: 'trailAtlas',
                        src: 'assets/desktop/14_feature/trail/skeleton.atlas',
                        data: {
                            imageMetadata: {
                                alphaMode: 'no-premultiply-alpha'
                            }
                        }
                    },
                    // meter effect
                    {
                        alias: 'meterEffectSkel',
                        src: 'assets/desktop/14_feature/meter_scarab_effect/meter_scarab_effect.skel',
                    },
                    {
                        alias: 'meterEffectAtlas',
                        src: 'assets/desktop/14_feature/meter_scarab_effect/meter_scarab_effect.atlas',
                        data: {
                            imageMetadata: {
                                alphaMode: 'no-premultiply-alpha'
                            }
                        }
                    },
                ]
            },
            {
                name: 'game-screen',
                assets: [
                    {
                        alias: 'background',
                        src: 'assets/desktop/6_basegame/base_bg.webp',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },

                    {
                        alias: 'beetle',
                        src: 'assets/desktop/beetle.webp',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    // Game Intro animation *********************
                    {
                        alias: 'gameIntroSkel',
                        src: 'assets/desktop/3_game_intro/game_intro.skel',
                    },
                    {
                        alias: 'gameIntroAtlas',
                        src: 'assets/desktop/3_game_intro/game_intro.atlas',
                        data: {
                            imageMetadata: {
                                alphaMode: 'no-premultiply-alpha'
                            }
                        }
                    },

                    //base game background animation
                    {
                        alias: 'baseBackgroundSkel',
                        src: 'assets/desktop/6_basegame/baseBgAnimation/basegame.skel',
                    },
                    {
                        alias: 'baseBackgroundAtlas',
                        src: 'assets/desktop/6_basegame/baseBgAnimation/basegame.atlas',
                        data: {
                            imageMetadata: {
                                alphaMode: 'no-premultiply-alpha'
                            }
                        }
                    },





                    // anticipation animation
                    {
                        alias: 'anticipationSkel',
                        src: 'assets/desktop/anticipation/anticipation.skel',
                    },
                    {
                        alias: 'anticipationAtlas',
                        src: 'assets/desktop/anticipation/anticipation.atlas',
                        data: {
                            imageMetadata: {
                                alphaMode: 'no-premultiply-alpha'
                            }
                        }
                    },

                    //Transition animation
                    {
                        alias: 'introTransitionSkel',
                        src: 'assets/desktop/14_feature/transition/transition.skel',
                    },
                    {
                        alias: 'introTransitionAtlas',
                        src: 'assets/desktop/14_feature/transition/transition.atlas',
                        data: {
                            imageMetadata: {
                                alphaMode: 'no-premultiply-alpha'
                            }
                        }
                    },
                    //Skull Fiesta
                    // {
                    //     alias: 'skull_coin_multiplier',
                    //     src: 'assets/desktop/11_font/skull_coin_multiplier/coin_multiplier.xml'
                    // },
                    // {
                    //     alias: 'skull_collect_multiplier',
                    //     src: 'assets/desktop/11_font/skull_collect_meter/meter_multiplier.xml'
                    // },
                    // {
                    //     alias: 'skull_win_digit',
                    //     src: 'assets/desktop/11_font/skull_win_digit/win_digit.xml'
                    // },
                    // {
                    //     alias: 'skull_coin_number',
                    //     src: 'assets/desktop/11_font/skull_coin_multiplier/coin_number.xml'
                    // },
                    //  Scarab Ascension
                    {
                        alias: 'scarab_wins_digit',
                        src: 'assets/desktop/11_font/scarab_wins/digit.xml'
                    },
                    {
                        alias: 'Nugie Romantic',
                        src: 'assets/desktop/11_font/Nugie Romantic.ttf'
                    },
                    {
                        alias: 'scarab_text_font',
                        src: 'assets/desktop/11_font/CinzelDecorative.ttf'
                    },
                    {
                        alias: 'poppins',
                        src: 'assets/desktop/11_font/poppins.bold.ttf'
                    },
                    {
                        alias: 'scarab_meter_default',
                        src: 'assets/desktop/11_font/meter_font/meterValue.xml'
                    },
                    {
                        alias: 'scarab_meter_active',
                        src: 'assets/desktop/11_font/meter_font/digit.xml'
                    },
                ],
            },
            {
                name: 'free-screen',
                assets: [
                    {
                        alias: 'backgroundFree',
                        src: 'assets/desktop/8_freegame/free_bg.webp',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },

                    //free game background animation
                    {
                        alias: 'freeBackgroundSkel',
                        src: 'assets/desktop/8_freegame/freeBgAnimation/freegame.skel',
                    },
                    {
                        alias: 'freeBackgroundAtlas',
                        src: 'assets/desktop/8_freegame/freeBgAnimation/freegame.atlas',
                        data: {
                            imageMetadata: {
                                alphaMode: 'no-premultiply-alpha'
                            }
                        }
                    },

                    //free game transition
                    // {
                    //     alias: 'transitionSkel',
                    //     src: 'assets/desktop/base/transition/transition.skel',
                    // },
                    // {
                    //     alias: 'transitionAtlas',
                    //     src: 'assets/desktop/base/transition/transition.atlas',
                    //     data: {
                    //         imageMetadata: {
                    //             alphaMode: 'no-premultiply-alpha'
                    //         }
                    //     }
                    // },

                    {
                        alias: 'beetle',
                        src: 'assets/desktop/beetle.webp',
                        data: {
                            alphaMode: 'no-premultiply-alpha'
                        }
                    },
                    // banner dust
                    {
                        alias: 'bannerDustSkel',
                        src: 'assets/desktop/14_feature/banner_dust/banner_dust.skel',
                    },
                    {
                        alias: 'bannerDustAtlas',
                        src: 'assets/desktop/14_feature/banner_dust/banner_dust.atlas',
                        data: {
                            imageMetadata: {
                                alphaMode: 'no-premultiply-alpha'
                            }
                        }
                    },
                ],
            },
            {
                name: 'sound',
                assets: [
                    {
                        alias: 'bet-level',
                        src: 'assets/desktop/13_sound/ui/betlevel.mp3',
                    },
                    {
                        alias: 'click',
                        src: 'assets/desktop/13_sound/ui/btn_spin.mp3',
                    },
                    {
                        alias: 'base_music_ambient',
                        src: 'assets/desktop/13_sound/base/Bg_ambient.mp3',
                    },
                    {
                        alias: 'base_music_loop',
                        src: 'assets/desktop/13_sound/base/Bg_Loop.mp3',
                    },
                    {
                        alias: 'free_background_loop',
                        src: 'assets/desktop/13_sound/freegame/Fg_Loop.mp3',
                    },
                    {
                        alias: 'stones_transition',
                        src: 'assets/desktop/13_sound/freegame/stones_transition.mp3',
                    },
                    {
                        alias: 'collectXtoWinX_message',
                        src: 'assets/desktop/13_sound/freegame/collectXtoWinX_message.mp3',
                    },
                    {
                        alias: 'framework_expanding',
                        src: 'assets/desktop/13_sound/freegame/framework_expanding.mp3',
                    },
                    {
                        alias: 'free_Game_Banner',
                        src: 'assets/desktop/13_sound/freegame/free_Game_Banner.mp3',
                    },
                    {
                        alias: 'total_win',
                        src: 'assets/desktop/13_sound/freegame/total_win.mp3',
                    },
                    {
                        alias: 'jackpot_upgraded',
                        src: 'assets/desktop/13_sound/freegame/jackpot_upgraded.mp3',
                    },
                    {
                        alias: 'scarab_symbol_firing',
                        src: 'assets/desktop/13_sound/freegame/scarab_symbol_firing.mp3',
                    },
                    {
                        alias: 'jackpot_update',
                        src: 'assets/desktop/13_sound/freegame/jackpot_update.mp3',
                    },
                    {
                        alias: 'Scatter_Trigger',
                        src: 'assets/desktop/13_sound/freegame/Scatter_Trigger.mp3',
                    },
                    {
                        alias: 'Intro_transition',
                        src: 'assets/desktop/13_sound/gameloading/Intro_transition.mp3',
                    },

                    {
                        alias: 'reel_stop',
                        src: 'assets/desktop/13_sound/spin/reel_stop.mp3',
                    },
                    {
                        alias: 'reels_spinning',
                        src: 'assets/desktop/13_sound/spin/reels_spinning.mp3',
                    },
                    {
                        alias: 'wild_flashing',
                        src: 'assets/desktop/13_sound/spin/wild_flashing.mp3',
                    },
                    {
                        alias: 'bonus_effect_adding_to_meter',
                        src: 'assets/desktop/13_sound/spin/bonus_effect_adding_to_meter.mp3',
                    },
                    {
                        alias: 'scatter_land',
                        src: 'assets/desktop/13_sound/spin/scatter_reel_higlighted.mp3',
                    },
                    {
                        alias: 'scatter_landing',
                        src: 'assets/desktop/13_sound/freegame/scatter_landing.mp3',
                    },
                    {
                        alias: 'scatter_anticipation_loop',
                        src: 'assets/desktop/13_sound/spin/scatter_reel_loop.mp3',
                    },
                    {
                        alias: 'symbol_win',
                        src: 'assets/desktop/13_sound/win/Win_Without_Multiplier.mp3',
                    },
                    {
                        alias: 'symbol_win_multiply',
                        src: 'assets/desktop/13_sound/win/Win_With_Multiplier.mp3',
                    },
                    {
                        alias: 'win_loop',
                        src: 'assets/desktop/13_sound/bigwin/Win_Loop.mp3',
                    },
                    //WINS
                    {
                        alias: 'Big_Win_Transition',
                        src: 'assets/desktop/13_sound/bigwin/Big_Win_Transition.mp3',
                    },
                    {
                        alias: 'Mega_Win_Transition',
                        src: 'assets/desktop/13_sound/bigwin/Mega_Win_Transition.mp3',
                    },
                    {
                        alias: 'Super_Win_Transition',
                        src: 'assets/desktop/13_sound/bigwin/Super_Win_Transition.mp3',
                    },
                    {
                        alias: 'Epic_Win_Transition',
                        src: 'assets/desktop/13_sound/bigwin/Epic_Win_Transition.mp3',
                    },
                    {
                        alias: 'win_tickup',
                        src: 'assets/desktop/13_sound/bigwin/Win_Count_up.mp3',
                    },
                    {
                        alias: 'win_tickup_end',
                        src: 'assets/desktop/13_sound/bigwin/Win_Count_up_End.mp3',
                    },
                ],
            },
        ],
    }
};

